// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3dm-9","footer":"ModalFilter_footer__2GINn"};